import React from "react";

export const dedicatoriaContent = (
  <div>
    <p className="content justified">
      Oswaldo Díaz Díaz se movía entre los círculos intelectuales más selectos de la época (tenemos conocimiento de su
      cercanía con Otto y León de Greiff, Eduardo Carranza, Arturo Camacho Ramírez, Germán Arciniegas, Sergio Trujillo
      Magnenat).
    </p>
    <p className="content justified">
      Aunque por la época en la que nació Don Os podría ser incluido en la generación de “Los nuevos”, sus inclinaciones
      literarias y dramáticas tenían otros matices.
    </p>
    <p className="content justified">
      Díaz Díaz murió de un infarto el viernes 15 de diciembre de 1967 en Bogotá y su partida causó sorpresa, tristeza y
      vacío para muchos de sus colegas de las diferentes ramas en las que se desempeñaba.
    </p>
  </div>
);
